import { render, staticRenderFns } from "./ArticleView.vue?vue&type=template&id=7d45235e&scoped=true&"
import script from "./ArticleView.vue?vue&type=script&lang=ts&"
export * from "./ArticleView.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleView.vue?vue&type=style&index=0&id=7d45235e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d45235e",
  null
  
)

export default component.exports